<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_invoice_no" class="col-sm-3 mb-0">
						Invoice No
					</label>
					<app-input
						id="inputs_invoice_no"
						class="col-sm-9"
						type="text"
						v-model="inputs.invoice_no"
						placeholder="Invoice No"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_class_name" class="col-sm-3 mb-0">
						Class Name
					</label>
					<app-input
						id="inputs_class_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.class_name"
						placeholder="Class Name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_class_type" class="col-sm-3 mb-0">
						Class Type
					</label>
					<app-input
						id="inputs_class_type"
						class="col-sm-9"
						type="text"
						v-model="inputs.class_type"
						placeholder="Class Type"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_status" class="col-sm-3 mb-0">
						Status
					</label>
					<app-input
						id="inputs_status"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_status"
						@input="setStatusValue"
						fetch-url="/master/lead-status?lead_status_id=null&per_page=50"
						:placeholder="'Status'"
						list-value-field="status"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sub_status" class="col-sm-3 mb-0">
						Sub Status
					</label>
					<app-input
						id="inputs_sub_status"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_sub_status"
						@input="setSubStatusValue"
						:fetch-url="`/master/lead-status?lead_status_id=${input_status.id}&per_page=50`"
						:placeholder="'Sub Status'"
						list-value-field="status"
						:disabled="
							this.input_status.id === '' ||
							this.input_status.id === null ||
							this.input_status.id === 0
						"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_reason" class="col-sm-3 mb-0">
						Reason
					</label>
					<app-input
						id="inputs_reason"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_reason"
						@input="setReasonValue"
						:fetch-url="`/master/lead-status-reason?lead_status_id=${input_sub_status.id}&per_page=50`"
						:placeholder="'Reason'"
						list-value-field="reason"
						:disabled="
							this.input_sub_status.id === '' ||
							this.input_sub_status.id === null ||
							this.input_sub_status.id === 0
						"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sc" class="col-sm-3 mb-0"> SC </label>
					<app-input
						id="inputs_sc"
						class="col-sm-9"
						type="text"
						v-model="inputs.sc"
						placeholder="SC"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_main_teacher" class="col-sm-3 mb-0">
						Main Teacher
					</label>
					<app-input
						id="inputs_main_teacher"
						class="col-sm-9"
						type="text"
						v-model="inputs.main_teacher"
						placeholder="Main Teacher"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_co_teacher" class="col-sm-3 mb-0">
						CO Teacher
					</label>
					<app-input
						id="inputs_co_teacher"
						class="col-sm-9"
						type="text"
						v-model="inputs.co_teacher"
						placeholder="CO Teacher"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_start_date" class="col-sm-3 mb-0">
						Start Date
					</label>
					<app-input
						id="inputs_start_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.start_date"
						placeholder="Start Date"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_end_date" class="col-sm-3 mb-0">
						End Date
					</label>
					<app-input
						id="inputs_end_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.end_date"
						placeholder="End Date"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_attendance" class="col-sm-3 mb-0">
						Attendance
					</label>
					<app-input
						id="inputs_attendance"
						class="col-sm-9"
						type="text"
						v-model="inputs.attendance"
						placeholder="Attendance"
						:required="true"
					/>
				</div>
				<!-- <div class="form-group row align-items-center">
                    <label for="inputs_email" class="col-sm-3 mb-0">
                        {{ $t('email') }}
                    </label>
                    <app-input id="inputs_email"
                               class="col-sm-9"
                               type="email"
                               v-model="inputs.email"
                               :placeholder="$t('email_type_input')"
                               :required="true"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_phone" class="col-sm-3 mb-0">
                        {{ $t('contact_number') }}
                    </label>
                    <app-input id="inputs_phone"
                               class="col-sm-9"
                               type="tel-input"
                               v-model="phone"
                               :placeholder="$t('type_contact_number')"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_status" class="col-sm-3 mb-0">
                        {{ $t('status') }}
                    </label>
                    <app-input id="inputs_status"
                               class="col-sm-9"
                               type="select"
                               :required="true"
                               v-model="inputs.status"
                               :list="statusLists"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_age" class="col-sm-3 mb-0">
                        {{ $t('age') }}
                    </label>
                    <app-input id="inputs_age"
                               class="col-sm-9"
                               type="number"
                               :max-number="100"
                               v-model="inputs.age"
                               :placeholder="$t('type_age')"/>
                </div>
                <div class="form-group row align-items-center mb-0">
                    <label class="col-sm-3 mb-0">
                        {{ $t('gender') }}
                    </label>
                    <app-input class="col-sm-9"
                               type="radio"
                               v-model="inputs.gender"
                               :list="genderLists"/>
                </div> -->
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "LogTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			phone: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
			input_status: this.value
				? this.value.status_id
					? {
							id: this.value.status_id.id || 0,
							status: this.value.status_id.status || "",
					  }
					: {
							id: this.value.status_id?.id || 0,
							status: this.value.status_id?.status || "",
					  }
				: {
						id: this.value.status_id.id || 0,
						status: this.value.status_id.status || "",
				  },
			input_sub_status: this.value
				? this.value.sub_status
					? {
							id: this.value.sub_status.id || 0,
							status: this.value.sub_status.status || "",
					  }
					: {
							id: this.value.sub_status?.id || 0,
							status: this.value.sub_status?.status || "",
					  }
				: {
						id: this.value.sub_status.id || 0,
						status: this.value.sub_status.status || "",
				  },
			input_reason: this.value
				? this.value.reason_id
					? {
							id: this.value.reason_id.id || 0,
							reason: this.value.reason_id.reason || "",
					  }
					: {
							id: this.value.reason_id?.id || 0,
							reason: this.value.reason_id?.reason || "",
					  }
				: {
						id: this.value.reason_id.id || 0,
						reason: this.value.reason_id.reason || "",
				  },
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.input_status = {
				id: this.inputs.status_id?.id || 0,
				status: this.inputs.status_id?.status || "",
			};

			this.input_sub_status = {
				id: this.inputs.sub_status_id?.id || 0,
				status: this.inputs.sub_status_id?.status || "",
			};

			this.input_reason = {
				id: this.inputs.reason_id?.id || 0,
				reason: this.inputs.reason_id?.reason || "",
			};
			this.preloader = false;
		},
		setStatusValue(data) {
			this.inputs.status_id = this.inputs.status_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.status_id = data.id;
			}
		},
		setSubStatusValue(data) {
			this.inputs.sub_status_id = this.inputs.sub_status_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.sub_status_id = data.id;
			}
		},
		setReasonValue(data) {
			this.inputs.reason_id = this.inputs.reason_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.reason_id = data.id;
			}
		},
	},
};
</script>
